import { AdminExpertsSchedule } from './AdminExpertsSchedule';

export default AdminExpertsSchedule;